module.exports = "/wp-content/plugins/farmacy/assets/js/images/flags-0b1ca148890222235a0f9903636ca21a.png";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/common/cart/img/flags.png
 ** module id = 552
 ** module chunks = 1 9 15 90
 **/